export const stationOperationalSettingsStatusValues = ['ok', 'requires_admin_action'] as const;
export type StationOperationalSettingsStatus = (typeof stationOperationalSettingsStatusValues)[number];

export interface StationOperationalSettingsDto {
  id: string;
  companyId: string;
  stationId: string;
  operationalTimeZone: string | null;
  configVersion: number;
  status: StationOperationalSettingsStatus;
  statusReason: string | null;
  lastConfiguredAt: string | null;
  lastChangedByUserId: string | null;
  lastChangeReason: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GetStationOperationalSettingsRequest {
  companyId: string;
  stationId: string;
}

export interface GetStationOperationalSettingsResponse {
  settings: StationOperationalSettingsDto;
}

export interface UpdateStationOperationalSettingsRequest {
  companyId: string;
  stationId: string;
  operationalTimeZone: string;
  ifVersion: number;
  changeReason?: string;
}

export interface UpdateStationOperationalSettingsResponse {
  settings: StationOperationalSettingsDto;
}
